import { atom } from 'recoil';

import { CustomerWhiteLabel } from '@hooks/types';

import { Atoms } from '../constants';

export const customerAtom = atom({
  key: Atoms.customer,
  default: {} as CustomerWhiteLabel,
});
